import { useState } from "react";
import { createQuestion } from "../firebase";

const initialForm = {
  name: "",
  email: "",
  question: "",
};

function QuestionForm({
  sectionId = "questions",
  sectionClassName = "section section-alt",
  containerClassName = "container narrow",
  title = "Suggest a topic or question",
  description = "Tell us one AI task you wish you could make easier. We'll pull real questions like yours into future Labs.",
}) {
  const [formData, setFormData] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      await createQuestion(formData);

      setStatus({
        type: "success",
        message:
          "Thanks for sharing. We'll use questions like yours to shape future Labs.",
      });
      setFormData(initialForm);
    } catch (submitError) {
      console.error("Question submission error:", submitError);
      setStatus({
        type: "error",
        message:
          "We couldn't submit your question right now. Please try again in a moment.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id={sectionId} className={sectionClassName}>
      <div className={containerClassName}>
        <h2>{title}</h2>
        <p>{description}</p>

        <form className="form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <label className="form-field" htmlFor="questionName">
              <span>Name</span>
              <input
                id="questionName"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </label>

            <label className="form-field" htmlFor="questionEmail">
              <span>Email</span>
              <input
                id="questionEmail"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <label className="form-field" htmlFor="questionText">
            <span>Question</span>
            <textarea
              id="questionText"
              name="question"
              rows="4"
              value={formData.question}
              onChange={handleChange}
              required
            />
          </label>

          <button className="btn btn-subtle" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit question"}
          </button>

          {status.message ? (
            <p className={`status-message ${status.type}`}>{status.message}</p>
          ) : null}
        </form>
      </div>
    </section>
  );
}

export default QuestionForm;
